<template>
  <v-container class="proof-integrations" fluid>
    <page-title title="Integrations"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <StorefrontManager
      widget-type="proof"
      title="Shopify proof widget app"
      subtitle="Manage proof-widget storefront installs per Shopify store, map them to campaigns, and validate the exact proof embed before you turn it on in the merchant theme."
      target-placeholder="#loyagram-proof-root"
    />
    <ZapierManager title="Zapier automation"></ZapierManager>
  </v-container>
</template>

<script>
import Tabs from '@/components/Tabs'
import StorefrontManager from '@/components/shopify/StorefrontManager'
import ZapierManager from '@/components/integrations/ZapierManager'
import routes from '@/route_names'

export default {
  name: 'ProofIntegrationsView',
  components: { StorefrontManager, Tabs, ZapierManager },
  computed: {
    tabSettings() {
      return {
        preselected: null,
        tabs: [
          {
            id: routes.PROOF_SETTINGS,
            label: 'Settings'
          },
          {
            id: routes.PROOF_INTEGRATIONS,
            label: 'Integrations'
          },
          {
            id: routes.PROOF_PUBLISH,
            label: 'Publish'
          }
        ]
      }
    }
  }
}
</script>
